const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

/* Mama Jewels (FR): de opties-app (Globo) toont een paar vaste Engelse teksten ("-- Please select --",
   "Selections will add € X to the price"); op de Franse site worden die direct vervangen. */
(function () {
  if (!/^fr/i.test(document.documentElement.lang || '')) return;
  var MAP = [
    [/^(\s*)-+\s*please\s+select\s*-+(\s*)$/i, '$1-- Veuillez choisir --$2'],
    [/selections will add/i, 'Vos options ajoutent'],
    [/\s+to the price\.?/i, ' au prix'],
    [/this field is required\.?/i, 'Ce champ est obligatoire.']
  ];
  var TEST = /please\s+select|selections will add|to the price|this field is required/i;
  function fix(root) {
    if (!root) return;
    if (root.nodeType === 3) root = root.parentNode;
    if (!root || !root.nodeType) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!TEST.test(v)) continue;
      MAP.forEach(function (m) { v = v.replace(m[0], m[1]); });
      if (v !== n.nodeValue) n.nodeValue = v;
    }
  }
  function start() {
    fix(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') fix(m.target);
        else m.addedNodes.forEach(fix);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Mama Jewels: na "Ajouter au panier" op een productpagina meteen naar de winkelwagen.
   Zonder dit gebeurde er op mobiel zichtbaar niets (de melding verscheen niet) en haakten klanten af.
   Alleen na een klik op de koopknop van het productformulier; we wachten tot alle /cart/add-verzoeken
   (Globo-opties, ketting, melkkit-app) klaar zijn. Mislukt het toevoegen (bv. verplichte maat), dan blijft de pagina staan. */
(function () {
  var armedAt = 0, pending = 0, added = false, timer = null;
  var CART = (window.routes && window.routes.cart_url) || '/cart';
  function armed() { return armedAt && Date.now() - armedAt < 20000; }
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '').split('#')[0].replace(/^https?:\/\/[^/]+/, '')); }
  function begin() { pending++; clearTimeout(timer); }
  function end(ok) {
    pending = Math.max(0, pending - 1);
    if (ok) added = true;
    if (!pending && added && armed()) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (pending || !armed()) return;
        armedAt = 0; added = false;
        var go = function () { window.location.href = CART; };
        var cap = setTimeout(go, 2500);
        (window.mjEnsureKit ? window.mjEnsureKit() : Promise.resolve()).then(function () { clearTimeout(cap); go(); }, function () { clearTimeout(cap); go(); });
      }, 150);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('product-form [type="submit"], product-form .product-form__submit');
    if (b) { armedAt = Date.now(); added = false; }
  }, true);
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isAdd(url)) return of.apply(this, arguments);
      begin();
      return of.apply(this, arguments).then(function (res) {
        var ok = res && res.ok;
        if (ok) {
          res.clone().json().then(function (j) { end(!(j && (j.status || j.errors))); }, function () { end(true); });
        } else end(false);
        return res;
      }, function (err) { end(false); throw err; });
    };
  }
  var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__mjAdd = isAdd(url); return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__mjAdd) {
      var x = this; begin();
      x.addEventListener('loadend', function () { end(x.status >= 200 && x.status < 300); });
    }
    return os.apply(this, arguments);
  };
})();

/* Mama Jewels: de cookiebanner van Shopify bedekte op mobiel ruim de helft van het scherm (ook de koopknop).
   Compacte versie: kleinere tekst, "Accepter" en "Refuser" even groot naast elkaar, voorkeuren als link eronder. */
(function () {
  var css = '@media screen and (max-width: 749px){' +
    '#shopify-pc__banner.shopify-pc__banner__dialog{left:8px !important;right:8px !important;bottom:8px !important;width:auto !important;max-width:none !important;padding:12px 14px 10px !important;border-radius:12px !important;box-shadow:0 6px 24px rgba(0,0,0,.18) !important}' +
    '#shopify-pc__banner .shopify-pc__banner__wrapper{display:block !important;padding:0 !important;margin:0 !important}' +
    '#shopify-pc__banner h2{font-size:14px !important;margin:0 0 4px !important}' +
    '#shopify-pc__banner .shopify-pc__banner__body p{font-size:11.5px !important;line-height:1.35 !important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns{display:flex !important;flex-direction:row !important;flex-wrap:wrap !important;align-items:stretch !important;gap:8px !important;margin:8px 0 0 !important;padding:0 !important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns button{width:auto !important;max-width:none !important;margin:0 !important;padding:9px 8px !important;font-size:13px !important;min-height:0 !important}' +
    '#shopify-pc__banner .shopify-pc__banner__btn-accept,#shopify-pc__banner .shopify-pc__banner__btn-decline{flex:1 1 0 !important;order:1}' +
    '#shopify-pc__banner .shopify-pc__banner__btn-manage-prefs{flex:1 1 100% !important;order:2;padding:2px !important;font-size:12px !important}' +
    '}';
  var s = document.createElement('style');
  s.id = 'mj-cookie-banner-compact';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

/* Mama Jewels (FR): de gratis melkkit hoort bij elke bestelling met een melksieraad. De app Cart Bot voegde hem alleen
   toe voor een vaste lijst varianten uit maart 2024, dus bij ruim 100 nieuwere sieraden ontbrak de kit (dan handwerk in de admin).
   Dit script zorgt dat er precies één kit in de winkelwagen zit zodra er een melksieraad in zit (herkend aan het
   producttype, dus nieuwe producten tellen vanzelf mee), en haalt de kit weg als er geen sieraad meer in zit. */
(function () {
  var KIT = 46892760793412;
  var TYPES = /^(bague|pendentif|boucles d.oreilles|bracelet|collier|hanger|charm|ketting|armband)$/i;
  var busy = false, timer = null, leaving = false;
  function isKit(i) { return Number(i.variant_id) === KIT; }
  function json(u, o) { return fetch(u, o).then(function (r) { return r.json(); }); }
  function post(u, body) { return json(u, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Mj-Kit': '1' }, body: JSON.stringify(body) }); }
  function ensure() {
    return json('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var kits = items.filter(isKit);
      var kitQty = kits.reduce(function (a, i) { return a + i.quantity; }, 0);
      var hasJewel = items.some(function (i) { return !isKit(i) && TYPES.test(String(i.product_type || '').trim()); });
      if (hasJewel && kitQty === 0) return post('/cart/add.js', { items: [{ id: KIT, quantity: 1 }] });
      if (hasJewel && kitQty > 1) return post('/cart/change.js', { id: kits[0].key, quantity: 1 });
    });
  }
  window.mjEnsureKit = ensure;
  // Klik op "Passer commande": eerst de kit regelen, dan pas door naar de checkout (max 2,5 s wachten)
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!b || b.dataset.mjKitOk) return;
    e.preventDefault(); e.stopPropagation();
    leaving = true;
    var done = false;
    var go = function () { if (done) return; done = true; b.dataset.mjKitOk = '1'; b.click(); };
    setTimeout(go, 2500);
    ensure().then(go, go);
  }, true);
  function check() {
    if (busy) return;
    busy = true;
    json('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var kits = items.filter(isKit);
      var kitQty = kits.reduce(function (a, i) { return a + i.quantity; }, 0);
      var hasJewel = items.some(function (i) { return !isKit(i) && TYPES.test(String(i.product_type || '').trim()); });
      var job = null;
      if (hasJewel && kitQty === 0) job = post('/cart/add.js', { items: [{ id: KIT, quantity: 1 }] });
      else if (hasJewel && kitQty > 1) job = post('/cart/change.js', { id: kits[0].key, quantity: 1 });
      else if (!hasJewel && kitQty > 0) job = post('/cart/change.js', { id: kits[0].key, quantity: 0 });
      if (!job) { try { sessionStorage.removeItem('mjKitReload'); } catch (e) {} return; }
      return job.then(function () {
        // op de winkelwagenpagina de weergave verversen, zodat de kit (niet) getoond wordt
        if (!leaving && /\/cart\/?$/.test(location.pathname)) {
          var k = 'mjKitReload'; var n = 0;
          try { n = +sessionStorage.getItem(k) || 0; } catch (e) {}
          if (n < 2) { try { sessionStorage.setItem(k, n + 1); } catch (e) {} location.reload(); }
        }
      });
    }).catch(function () {}).then(function () { busy = false; });
  }
  function later(ms) { clearTimeout(timer); timer = setTimeout(check, ms); }
  // bij elke pagina (na Cart Bot) en na elke winkelwagenwijziging opnieuw controleren
  function start() {
    try { if (!/\/cart\/?$/.test(location.pathname)) sessionStorage.removeItem('mjKitReload'); } catch (e) {}
    later(/\/cart\/?$/.test(location.pathname) ? 200 : 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = init && init.headers && init.headers['X-Mj-Kit'];
      var p = f.apply(this, arguments);
      if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { later(1200); }, function () {});
      return p;
    };
  }
})();
